export default __webpack_public_path__ + "static/media/4_FiyatMontajHesaplamaÖrnekExcelData.3a320ae2.xlsx";